<div class="row justify-content-center" [hidden]="!this.isloaderVisible">
  <div class="col-lg-8 col-md-12">
    <div style="height: 70px" class="d-flex align-items-center justify-content-center">
      <div style="" class="loading"></div>
    </div>
  </div>
</div>
<div [hidden]="this.isloaderVisible">
  <div #tableContainer class="table-responsive">
    <table class="table wre-table fixed-column mb-0">
      <thead>
        <tr>
          <th class="action fixed-column">&nbsp;</th>
          <th class="id" hidden="true">Id</th>
          <th class="order text-center">Order No.</th>
          <th class="active text-center">Active</th>
          <th class="name">Name</th>
        </tr>
      </thead>
      <tbody class="mb-0 pb-0">
        @for (appCategory of appCategories; track appCategory) {
          <tr>
            <td class="fixed-column action">
              <div ngbDropdown container="body">
                <button class="btn btn-secondary" ngbDropdownToggle>Action</button>
                <div ngbDropdownMenu>
                  @if (hasEditPermission) {
                    <button (click)="onEdit(appCategory.id)" ngbDropdownItem>Edit</button>
                    @if (appCategory.isValid) {
                      <button (click)="onStatusChange(appCategory.id)" ngbDropdownItem>
                        Disable
                      </button>
                    } @else {
                      <button (click)="onStatusChange(appCategory.id)" ngbDropdownItem>
                        Enable
                      </button>
                    }
                  }
                  @if (hasDeletePermission) {
                    <button
                      (click)="onDelete(appCategory.id, appCategory.name)"
                      class="delete"
                      ngbDropdownItem>
                      Delete
                    </button>
                  }
                </div>
              </div>
            </td>
            <td class="id" hidden="true">{{ appCategory.id }}</td>
            <td class="order text-center">{{ appCategory.orderNo }}</td>
            <td class="active text-center">
              @if (appCategory.isValid) {
                <i class="fa fa-check" aria-hidden="true"></i>
              } @else {
                <i class="fa fa-times" aria-hidden="true"></i>
              }
            </td>
            <td class="name">{{ appCategory.name }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
